
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 100 100"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke-width":"6","fill":"none"}},[_c('path',{attrs:{"d":"M9 7.794l3.924-.846a176.048 176.048 0 0174.151 0L91 7.794 88.4 60.39C87.389 80.895 70.496 97 50 97c-20.495 0-37.387-16.105-38.4-36.61L9 7.794z"}}),_c('path',{attrs:{"d":"M42.505 44.006c0-4.39-3.552-7.95-7.935-7.95-4.383 0-7.936 3.56-7.936 7.95m45.85 0c0-4.39-3.553-7.95-7.936-7.95-4.382 0-7.935 3.56-7.935 7.95M35.452 64.32c0 6.341 6.316 11.482 14.107 11.482 7.792 0 14.108-5.14 14.108-11.482"}})])])
          )
        }
      }
    